import { api } from './client';
import type { RateCatalogItem, EstimateLine, EstimateDetail, Paginated } from '@/types';

export const rateCatalogApi = {
  async list(filters: { norm_base?: string; category?: string; search?: string } = {}): Promise<RateCatalogItem[]> {
    const { data } = await api.get<Paginated<RateCatalogItem>>('/rate-catalog/', { params: filters });
    return data.results ?? (data as unknown as RateCatalogItem[]);
  },
};

export const estimateEditorApi = {
  async get(id: number): Promise<EstimateDetail> {
    const { data } = await api.get<EstimateDetail>(`/estimates/${id}/`);
    return data;
  },
  async create(payload: { number: string; contract: number; kind?: string; norm_base?: string }): Promise<EstimateDetail> {
    const { data } = await api.post<EstimateDetail>('/estimates/', payload);
    return data;
  },
  async lines(estimateId: number): Promise<EstimateLine[]> {
    const { data } = await api.get<EstimateLine[]>(`/estimates/${estimateId}/lines/`);
    return data;
  },
  async addLine(payload: Partial<EstimateLine> & { estimate: number; line_number: number; code: string; name: string; unit: string; volume: string; unit_cost_total: string }): Promise<EstimateLine> {
    const { data } = await api.post<EstimateLine>('/estimate-lines/', payload);
    return data;
  },
  async updateLine(id: number, payload: Partial<EstimateLine>): Promise<EstimateLine> {
    const { data } = await api.patch<EstimateLine>(`/estimate-lines/${id}/`, payload);
    return data;
  },
  async deleteLine(id: number): Promise<void> { await api.delete(`/estimate-lines/${id}/`); },
};
